const PERMISSION = {
  CREATE: 'c',
  READ: 'r',
  UPDATE: 'u',
  DELETE: 'd',
};

export default PERMISSION;
